import {
  createContext,
  Dispatch,
  ReactNode,
  SetStateAction,
  useState,
} from "react";
import { ServiceDetails } from "../../store/verification/models/internal";

type ContentType = Array<
  Omit<ServiceDetails["documents"][number], "type"> & {
    file: { data: string; type: string | null };
    sideView?: ReactNode;
    type: string;
  }
>;

export type AllImages = {
  files: ContentType;
  setFiles: Dispatch<SetStateAction<ContentType>>;
};

export const AllImages = createContext<AllImages>(
  (undefined as any) as AllImages
);

export function AllImagesProvider({ children }: { children: ReactNode }) {
  const [files, setFiles] = useState<ContentType>([]);

  return (
    <AllImages.Provider value={{ files, setFiles }}>
      {children}
    </AllImages.Provider>
  );
}
